export default __webpack_public_path__ + "static/media/bfit_logo_only.47f047dd.svg";